import { getSubdomain, fetchWithAuth } from '../helpers';
import { API_PASSWORD } from '../config';






// ✅ الدالة النهائية الصحيحة
// ✅ الدالة لجلب المصروفات مع رقم الفرع في الـ URL
export const getRootExpenses = async () => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD || "Project102$_";

  // 👈 جلب branch_id من localStorage
  const branchId = localStorage.getItem("branch_id");

  if (!branchId) {
    throw new Error("❌ لم يتم العثور على branch_id في localStorage");
  }

  // ✅ إدراج رقم الفرع داخل الـ URL مباشرة
  const apiUrl = `https://${subdomain}.restocash.app/api/get/root/expenses/${branchId}?api_password=${apiPassword}`;

  try {
    console.log("📡 إرسال طلب لجلب المصروفات عبر:", apiUrl);

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) {
      const text = await response.text();
      console.error("❌ استجابة غير صالحة:", text);
      throw new Error("فشل في جلب المصروفات.");
    }

    const data = await response.json();
    console.log("✅ تم جلب المصروفات بنجاح:", data);
    return data;
  } catch (error) {
    console.error("🔥 خطأ أثناء الاتصال بالسيرفر:", error);
    throw error;
  }
};




export const createExpense = async (expense) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/expense?api_password=${API_PASSWORD}`;
  
  const token = localStorage.getItem("token");

  const formData = new FormData();
  formData.append("root_id", expense.root_id);
  formData.append("bank_id", expense.bank_id);
  formData.append("amount", expense.amount);
  formData.append("expense_date", expense.expense_date);
  formData.append("description", expense.description);
  formData.append("title", expense.title);

  // ✅ أنواع الملفات المسموحة
  const allowedTypes = [
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/bmp",
  ];

  if (expense.file) {
    if (!allowedTypes.includes(expense.file.type)) {
      throw new Error("❌ نوع الملف غير مسموح. الصيغ المسموحة: PDF, PNG, JPEG, JPG, BMP");
    }
    formData.append("file", expense.file);
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في إضافة المصروف");
  }

  return data;
};



// ✅ دالة تعديل مصروف
export const updateExpense = async (id, expenseData) => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD || "Project102$_";

  const apiUrl = `https://${subdomain}.restocash.app/api/update/expense/${id}?api_password=${apiPassword}`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST", // أو PUT حسب ما السيرفر بيقبل
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(expenseData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "❌ فشل في تعديل المصروف.");
    }

    console.log("✅ تم تعديل المصروف:", data);
    return data;
  } catch (error) {
    console.error("🔥 خطأ أثناء تعديل المصروف:", error);
    throw error;
  }
};




export const deleteExpense = async (expenseId) => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD || "Project102$_";

  const apiUrl = `https://${subdomain}.restocash.app/api/delete/expense/${expenseId}?api_password=${apiPassword}`;

  try {
    console.log("📡 إرسال طلب لحذف المصروف:", apiUrl);

    const response = await fetch(apiUrl, {
      method: "GET", // ✅ زي ما موضح في Postman
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في حذف المصروف:", data);
      throw new Error(data?.message || "فشل في حذف المصروف.");
    }

    console.log("✅ تم حذف المصروف بنجاح:", data);
    return data;
  } catch (error) {
    console.error("🔥 خطأ أثناء الاتصال بالسيرفر:", error);
    throw error;
  }
};

